import { render, staticRenderFns } from "./PolicyRuleTarget.vue?vue&type=template&id=123cca60&scoped=true&"
import script from "./PolicyRuleTarget.vue?vue&type=script&lang=js&"
export * from "./PolicyRuleTarget.vue?vue&type=script&lang=js&"
import style0 from "./PolicyRuleTarget.vue?vue&type=style&index=0&id=123cca60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123cca60",
  null
  
)

export default component.exports